"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _animate = _interopRequireDefault(require("animate.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _cccisdReactRouter = require("cccisd-react-router");
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus2"));
var _arrowUp = _interopRequireDefault(require("cccisd-icons/arrow-up6"));
var _Header = _interopRequireDefault(require("../../components/Header"));
var _LackingPermissions = _interopRequireDefault(require("../../components/LackingPermissions"));
var _NoProjectsMessage = _interopRequireDefault(require("../../components/NoProjectsMessage"));
var _keepScrollPosition = _interopRequireDefault(require("../../helpers/keepScrollPosition.js"));
var _questPermissionsByArea = _interopRequireDefault(require("../../helpers/questPermissionsByArea.js"));
var _admin = require("../../reducers/admin.js");
var _admin2 = require("../../selectors/admin.js");
var _CycleForm = _interopRequireDefault(require("./CycleForm"));
var _CycleCard = _interopRequireDefault(require("./CycleList/CycleCard"));
var _DeployTrack = _interopRequireDefault(require("../DeployTrack"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _style = _interopRequireDefault(require("./style.css"));
var _useEnsureDeploymentIds = _interopRequireDefault(require("../../hooks/useEnsureDeploymentIds"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Fortress = window.cccisd.fortress;
var Deploy = function Deploy(_ref) {
  var _currentAssignment$se, _currentAssignment$se2;
  var dispatch = _ref.dispatch,
    project = _ref.project,
    projectAssignments = _ref.projectAssignments,
    projectLinks = _ref.projectLinks,
    assignmentId = _ref.assignmentId,
    deployment = _ref.deployment;
  if (!Fortress.hasAnyAccess(_questPermissionsByArea["default"].deploy.permissions, project.groupId)) {
    return /*#__PURE__*/_react["default"].createElement(_LackingPermissions["default"], null);
  }
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    showArrow = _useState2[0],
    setShowArrow = _useState2[1];
  var match = (0, _cccisdReactRouter.useRouteMatch)();
  var currentAssignment = projectAssignments.find(function (item) {
    return item.assignmentId === assignmentId;
  });
  (0, _useEnsureDeploymentIds["default"])();

  // Deploy tab filters out all child deployments of a repeatable Parent,
  // so make sure the currently selected one is always a Parent (cannot edit a Child)
  if (deployment !== null && deployment !== void 0 && deployment.parentDeploymentId) {
    var firstParentDeployment = Array.isArray(currentAssignment.deploymentList) && currentAssignment.deploymentList.find(function (dep) {
      return !dep.parentDeploymentId;
    });
    var selected = firstParentDeployment !== null && firstParentDeployment !== void 0 && firstParentDeployment.deploymentId ? [firstParentDeployment.deploymentId] : [0];
    dispatch((0, _admin.setSelectedDeploymentIds)(selected));
    dispatch((0, _admin.setCurrentDeploymentIds)(selected));
    return /*#__PURE__*/_react["default"].createElement("span", null);
  }
  var hasSurveys = currentAssignment && Array.isArray(currentAssignment.surveylistList) && currentAssignment.surveylistList.length > 0 && Array.isArray(currentAssignment.surveylistList[0].surveyList) && currentAssignment.surveylistList[0].surveyList.length > 0;
  var noLanguagesReadyForDeploy = (currentAssignment === null || currentAssignment === void 0 ? void 0 : (_currentAssignment$se = currentAssignment.settings) === null || _currentAssignment$se === void 0 ? void 0 : _currentAssignment$se.languages) && (currentAssignment === null || currentAssignment === void 0 ? void 0 : (_currentAssignment$se2 = currentAssignment.settings) === null || _currentAssignment$se2 === void 0 ? void 0 : _currentAssignment$se2.languages.length) === 0;
  function renderDeploymentInfo() {
    if (!projectAssignments || Array.isArray(projectAssignments) && projectAssignments.length === 0) {
      return /*#__PURE__*/_react["default"].createElement(_NoProjectsMessage["default"], null);
    }
    if (!hasSurveys) {
      var hasDesignPermissions = Fortress.hasAnyAccess(_questPermissionsByArea["default"].design.permissions, project.groupId);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].noSurveys
      }, /*#__PURE__*/_react["default"].createElement("h3", null, "This Quest has no Surveys."), hasDesignPermissions && /*#__PURE__*/_react["default"].createElement("p", null, "Select a different Quest, or create Surveys in the \"", /*#__PURE__*/_react["default"].createElement(_cccisdReactRouter.Link, {
        to: projectLinks.design
      }, "Design"), "\" tab."));
    }
    return project && deployment && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_CycleCard["default"], {
      assignment: currentAssignment,
      cycle: deployment
    }), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement(_DeployTrack["default"], {
      match: match
    }));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].deployWrapper
  }, /*#__PURE__*/_react["default"].createElement(_Header["default"], {
    showProjectDropdown: true,
    showQuestCount: false,
    showQuestDropdown: true,
    showDeploymentDropdown: true,
    showRepeatableDeploymentChildren: false,
    deploymentDropdownNotMulti: true,
    rightSection: /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].rightSection
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('text-primary', _style["default"].infoBubble)
    }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: hasSurveys ? 'A Data Collection Wave is a specifically configured quest against which data is collected.' : 'You need to add surveys in the "Design" tab before you can create a Data Collection Wave.'
    }, /*#__PURE__*/_react["default"].createElement(_info["default"], null))), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      trigger: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-primary",
        disabled: !hasSurveys,
        onClick: function onClick(e) {
          if (noLanguagesReadyForDeploy) {
            e.stopPropagation();
            (0, _cccisdNotification["default"])({
              type: 'danger',
              message: 'No languages are ready for deploy'
            });
          }
        }
      }, /*#__PURE__*/_react["default"].createElement(_plus["default"], {
        spaceRight: true
      }), "Create Data Collection Wave"), hasSurveys && Array.isArray(currentAssignment.deploymentList) && currentAssignment.deploymentList.length === 0 && showArrow && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(_style["default"].bounceArrow, _animate["default"].animated, _animate["default"].bounce, _animate["default"].infinite)
      }, /*#__PURE__*/_react["default"].createElement(_arrowUp["default"], null))),
      title: "New Data Collection Wave",
      size: "large",
      beforeShow: function beforeShow() {
        return setShowArrow(false);
      },
      beforeClose: function beforeClose() {
        return setShowArrow(true);
      }
    }, hasSurveys && /*#__PURE__*/_react["default"].createElement(_CycleForm["default"], {
      assignment: currentAssignment
    })))
  }), renderDeploymentInfo());
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    project: (0, _admin2.getCurrentProject)(state.assignment.admin),
    assignmentId: state.assignment.admin.currentAssignmentId,
    deployment: (0, _admin2.getCurrentDeployment)(state.assignment.admin),
    projectAssignments: (0, _admin2.getCurrentProjectAssignments)(state.assignment.admin),
    projectLinks: (0, _admin2.getProjectLinks)(state.assignment.admin)
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)((0, _keepScrollPosition["default"])(Deploy));